import { ValidatorOptions } from '.';
import { RequiredValidator } from './required.validator';
import { ValidationResult } from './types.validators';
import { Validator } from './validator';

export class EmailValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        if (!value || value.length < 1) {
            return new RequiredValidator().validate(value, options);
        }

        if (!this.isValidEmail(value)) {
            return new ValidationResult(false, 'Please enter a valid email address');
        }

        return new ValidationResult(true);
    }

    private isValidEmail(value: string | undefined): boolean {
        if (!value) {
            return true;
        }

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/;

        return emailRegex.test(value);
    }
}
